<template>
    <div class="property-home-page">
        <app-home-page />
        <property-requirement-steps />
        <subproperty-dashboard-finantial
            v-if="subproperties.length > 0 && !isPropertyNBA"
            :subproperties="subproperties"
            :hidden-links="false"
        />
        <property-dashboard />
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import HomePage from '@modules/home/components/home-page.vue';
import PropertyRequirementSteps from '@modules/property/components/property-requirement-steps.vue';
import PropertyDashboard from '@modules/property/components/property-dashboard.vue';
import SubpropertydashboardFinantial from '@modules/subproperty/components/subproperty-dashboard-finantial.vue';

export default {
    name: 'PropertyHomePage',

    computed: {
        ...mapGetters({
            subproperties: 'subproperty/list/rows',
            isPropertyNBA: 'auth/manage/isPropertyNBA',
        }),
    },

    methods: {
        ...mapActions({
            doResetSubproperties: 'subproperty/list/doReset',
        })
    },

    async mounted() {
        await this.doResetSubproperties();
    },

    components: {
        [HomePage.name]: HomePage,
        [PropertyRequirementSteps.name]: PropertyRequirementSteps,
        [PropertyDashboard.name]: PropertyDashboard,
        [SubpropertydashboardFinantial.name]: SubpropertydashboardFinantial,
    },
}
</script>
